class Stack {
    constructor(capacity = Number.POSITIVE_INFINITY) {
        this.items = [];
        // 不可改变
        Object.defineProperty(this, 'capacity', {
            value: capacity,
            writable: false
        });
    }
    toArray() {
        return this.items;
    }
    push(p) {
        if (this.isFull()) {
            return new Error('has full');
        }
        else {
            this.items.push(p);
            return this.size();
        }
    }
    pop() {
        return this.items.pop();
    }
    peek() {
        return this.items[this.size() - 1];
    }
    isEmpty() {
        return this.size() === 0;
    }
    isFull() {
        return this.size() === this.capacity;
    }
    clear() {
        this.items = [];
    }
    size() {
        // set/ map 都是size返回容量
        return this.items.length;
    }
}
export { Stack };
